import './App.css';

/**
 * Renders a component displaying the appointed date with a custom message.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.appointedDate - The date of appointment in a format parseable by the Date constructor.
 * @param {string} props.content - The text content to display before the formatted date.
 * @returns {JSX.Element} A React component that displays the formatted appointed date with the provided content.
 */
function AppointedDate(props) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  let date;
  date = props.appointedDate;

  
  return (
    <>
        <div className="appointed-date">
            <h2 className='sub-title'>{props.content} <strong>{new Date(date).toLocaleDateString("en-US", options)}.</strong></h2>
        </div>
    </>
  );
}

export default AppointedDate;